/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import styles from "./App.module.scss";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import WorkListPage from "./pages/workList/index.js";
import NewWorkPage from "./pages/newWork/index.js";
import DocList from "./pages/docList/index.js";
import Documents from "./pages/documents/index.js";
import { Auth } from "./config/auth";
import { api } from "./config/api";
import React, { useContext, useEffect, useState } from "react";
import LoginPage from "./pages/login/index";
import SignUpPage from "./pages/signUp/SignUpPage";
import WelcomePage from "./pages/welcome/WelcomePage";
import { captureFirstTouch, sendFirstTouchOnce } from "./utils/firstTouch";
import CostProjectsPage from "./pages/costProjects/CostProjectsPage";
import MyPage from "./pages/myPage/MyPage";
import NoticeList from "./pages/noticeList/noticeList";
import NoticeDetail from "./pages/noticeList/noticeDetail/noticeDetail";
// import { Menu, Dropdown, Badge } from "antd";
import Notifications from "@material-ui/icons/Notifications";
import PersonIcon from "@material-ui/icons/Person";
import { pages } from "./constants/PagePaths";
import { useHistory, Redirect } from "react-router-dom";
import { trackRoute } from "./services/eventLog";
import AlertContext from "./contexts/AlertContext";
import LectureRoomContainer from "./pages/lectureRoom/LectureRoomContainer";
import LectureRoomStudyContainer from "./pages/lectureRoom/LectureRoomStudyContainer";
import SampleStatementListContainer from "./pages/sampleStatementList/SampleStatementListContainer";
import InquiryContainer from "./pages/inquiry/InquiryContainer";
import EducationApplicationContainer from "./pages/educationApplication/EducationApplicationContainer";

import _ from "lodash";
import FindAccountContainer from "./pages/findAccount/FindAccountContainer";
import MainContainer from "./pages/main/MainContainer";
import { privacyPolicy, termsOfService } from "./constants/Terms";
import PaymentContainer from "./pages/payment/PaymentContainer";
import SubscriptionPaymentContainer from "./pages/payment/SubscriptionPaymentContainer";
import { util } from "./config/util";
import { Cookies } from "./constants/Cookies";
import WithdrawalContainer from "./pages/withdrawal/WithdrawalContainer";
import ChangePasswordContainer from "./pages/changePassword/ChangePasswordContainer";
import GA4React from "ga-4-react";
import DupLoginContext from "./contexts/DupLoginContext";
import { LoadingContext } from "./contexts/LoadingContext";
import SampleStatementDetailContainer from "./pages/sampleStatementDetail/SampleStatementDetailContainer";
import Contact from "./pages/contact/Contact";
import InquiryBoard from "./pages/contact/InquiryBoard";
// import RequestApplication from "./pages/contact/RequestApplication";
import sns2 from "./assets/img/icon/youtube.png";
import UserBoardListContainer from "./pages/userBoardList/UserBoardListContainer";
import UserBoardDetailContainer from "./pages/userBoardDetail/UserBoardDetailContainer";
import UserBoardFormContainer from "./pages/userBoardForm/UserBoardFormContainer";
import ServiceRequestDocContainer from "./pages/contact/serviceRequestDoc/ServiceRequestDocContainer";
import VideoMain from "./pages/video/components/main/VideoMain";
import ScrollToTop from "./modules/ScrollToTop";
import DataListContainer from "./pages/constructionData/DataListContainer";
import ExcelContainer from "./pages/excel/ExcelContainer";
import ExcelContractContainer from "./pages/excelContract/ExcelContractContainer";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AlarmModal from "./components/AlarmModal";
import MyPageLayout from "./components/MyPageLayout";
import { ExcelProvider } from "./contexts/ExcelContext";
import { TenantInfo, TenantProvider, applyTenantChrome, backToPortalIfTenant, isTenantAllowedPath, portalHomeUrl, rememberTenantMode, setTenantInfo, tenantFromBootstrap } from "./contexts/TenantContext";
import CouponContainer from "./pages/myPage/components/CouponContainer";
import LevelTest from "./pages/levelTest/LevelTest";
import LevelTestContainer from "./pages/levelTest/LevelTestContainer";
import LevelTestComplete from "./pages/levelTest/LevelTestComplete";
import Video from "./pages/video/components/video/Video";
import RequestApplicationContainer from "./pages/requestApplication/RequestApplicationContainer";
import MyPageVideo from "./pages/myPage/MyPageVideo";
import MyPagePayment from "./pages/myPage/MyPagePayment";
import MyPagePaymentMethod from "./pages/myPage/MyPagePaymentMethod";
import CostProjectsDetailPage from "./pages/costProjects/CostProjectsDetailPage";
import RequestApplication from "./pages/contact/RequestApplication";
import DataDetailContainer from "./pages/constructionData/DataDetailContainer";
import PaymentComplete from "./pages/payment/PaymentComplete";
import MyPageQna from "./pages/myPage/MyPageQna";
import MyPageQnaDetail from "./pages/myPage/MyPageQnaDetail";
import Callback from "./pages/oauth/Callback";
import MyPageContact from "./pages/myPage/MyPageContact";
import MyPageContactDetail from "./pages/myPage/MyPageContactDetail";
import SocialSignup from "./pages/oauth/SocialSignUp";
import MyPageQnaReplyDetail from "./pages/myPage/MyPageQnaReplyDetail";
import CommunityHub from "./components/Community/CommunityHub";
import CommunityPage from "./components/Community/CommunityPage";
import PostDetail from "./components/Post/PostDetail";
import { CategoryProvider } from "./contexts/CategoryContext";
import AICommunityPage from "./components/Community/AICommunityPage";
import AIPostDetail from "./components/Post/AIPostDetail";
import MyPosts from "./pages/myPage/MyPosts";
import MyComments from "./pages/myPage/MyComments";
import UserPermissions from "./pages/myPage/UserPermissions";
// import ServiceRequest from "./pages/contact/ServiceRequest";
// import ServiceDetailPage from "./pages/contact/ServiceDetailPage";
// import ServiceStatusPage from "./pages/service/ServiceStatusPage";
// import Dashboard from "./pages/dashboard/Dashboard";
// import ProjectDetailPage from "./pages/project/ProjectDetailPage";
// import { ProjectProvider } from "./contexts/ProjectContext";
// import ServiceApplicationStatus from "./pages/service/ServiceApplicationStatus";
// import ExpertList from "./pages/expert/ExpertList";
// import ExpertDetail from "./pages/expert/ExpertDetail";
// import ExpertMatchingPage from "./pages/expert/ExpertMatchingPage";
// import { ExternalProjectDetail } from "./pages/project/ExternalProjectDetail";
import CadProPage from "./components/CadPro/CadProPage";
import VerificationPage from "./pages/verification/VerificationPage";
import Section1and2 from "./components/Landing/Section1and2";
import Section3and4 from "./components/Landing/Section3and4";
import Section5and6 from "./components/Landing/Section5and6";
import Section7and8 from "./components/Landing/Section7and8";
import ExpressCheckoutModal from "./components/Landing/components/ExpressCheckoutModal";
import Section9 from "./components/Landing/Section9";
import './components/Landing/styles/section1and2.scss';
import './components/Landing/styles/section3and4.scss';
import './components/Landing/styles/section5and6.scss';
import './components/Landing/styles/section7and8.scss';
import './components/Landing/styles/section9.scss';

declare global {
  interface Window {
    AOS: any;
  }
}

function App() {
  //IE일 경우 안내페이지로 리다이렉트
  const isIE = /*@cc_on!@*/ false || !!(document as any).documentNode;
  if (isIE) {
    window.location.href = "https://ie.ddusul.com";
  }
  const location = useLocation();

  useEffect(() => {
    const { AOS } = window;
    AOS.init();
  }, [location]);

  // 계측: 결제 화면 진입 경로(직전 경로) 추적
  useEffect(() => {
    trackRoute(location.pathname);
  }, [location]);

  const auth = Auth.getInstance();

  const [currentEmail, setCurrentEmail] = useState();
  // 커스텀 견적서 접근 권한 — 서버(user/info)가 판정해 준다.
  // 어드민 명단(관리 > 커스텀견적서 테스터)이 여기로 반영되므로 프런트에 이메일을 박지 않는다.
  const [ceTester, setCeTester] = useState<boolean | undefined>(undefined);
  // 발주처(B2B) 모드: 회사 포털(광해 등) 소속 계정이면 콘엑스 표시를 모두 걷어낸다(헤더·푸터·탭 제목·파비콘·상담 위젯·구매 유도).
  const [tenantInfo, setTenantInfoState] = useState<TenantInfo | null>(null);
  const setTenant = (t: TenantInfo | null) => { setTenantInfo(t); rememberTenantMode(t); setTenantInfoState(t); };
  useEffect(() => {
    if (!tenantInfo) return;
    const undo = applyTenantChrome(tenantInfo);
    // 엑셀 자동화·공사 서류 밖의 콘엑스 화면(랜딩·결제·마이페이지 등)은 발주처 모드에서 열지 않는다.
    if (!isTenantAllowedPath(location.pathname)) { window.location.replace(portalHomeUrl()); }  // 라우터 location: 해시 라우팅에서도 앱 경로
    return undo;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantInfo, location.pathname]);
  const [alarms, setAlarms] = useState<any>([]);
  const [unreadCount, setUnreadCount] = useState(0);
  
  // ExpressCheckoutModal 상태 관리
  const [isExpressModalOpen, setIsExpressModalOpen] = useState(false);
  const [modalSelectedPlans, setModalSelectedPlans] = useState([]);
  const [modalTotalAmount, setModalTotalAmount] = useState(0);
  const [modalIsMonthly, setModalIsMonthly] = useState(true);
  
  const history = useHistory();
  const alert = useContext(AlertContext);
  const dlContext = useContext(DupLoginContext);

  const clearUserInfo = () => {
    // 발주처 모드로 쓰던 사람은 콘엑스 메인이 아니라 포털 로그인으로(콘엑스를 보면 안 된다).
    if (backToPortalIfTenant()) { util.deleteCookie(Cookies.authKey); return; }
    setTenant(null);
    try {
      api.logout();
      history.push(pages.index);
    } catch (err) {}
    setCurrentEmail(undefined);
    setCeTester(undefined);
    setVendorInfo(null);
    util.deleteCookie(Cookies.authKey);
    window.location.reload();
  };

  const checkUser = () => {
    // 이 브라우저의 첫 유입 경로를 UTM 을 URL 에서 지우기 전에 저장 (GA 로딩이 막혀도 동작하게 먼저 호출)
    captureFirstTouch();
    const buildGoogleAanlyticsAsync = async () => {
      try {
        const gTagId = process.env.REACT_APP_GTAG_ID;
        const ga4react = new GA4React(gTagId!);
        await ga4react.initialize();

        // UTM 파라미터 정리 - GA4 page_view 캡처 후 URL에서 제거
        // (지우기 전에 이 브라우저의 첫 유입 경로를 저장해 둔다 — 가입 후 event_log first_touch 로 보냄)
        captureFirstTouch();
        const url = new URL(window.location.href);
        const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
        let hasUtm = false;
        utmParams.forEach(param => {
          if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            hasUtm = true;
          }
        });
        if (hasUtm) {
          window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        }

        // (삭제 10-08) 로그인 토큰(authKey)을 GA user_id 로 보내던 코드. 변수명 오타로 동작하지 않았지만
        // 고치는 순간 인증 토큰이 구글로 나가므로 지움. user_id 가 필요하면 토큰이 아닌 내부 id 를 써야 한다.
      } catch (error) {}
    };

    buildGoogleAanlyticsAsync();
    if (!util.getCookie(Cookies.authKey)) { if (backToPortalIfTenant()) { return; } setTenant(null); }
    if (util.getCookie(Cookies.authKey)) {
      api
        .getMyInfo()
        .then((result: any) => {
          sendFirstTouchOnce();
          //로그인 되어있음
          auth.email = result.data.email;
          auth.lastName = result.data.lastName;
          setCurrentEmail(auth.email);
          setCeTester(result.data.is_custom_estimate_tester);
          api
            .getTenantBootstrap()
            .then((boot: any) => {
              setTenant(tenantFromBootstrap(boot));
            })
            .catch(() => setTenant(null));
          api.getAlarmsAsync(0, 10, false).then((result: any) => {
            const data = result?.data?.alarms?.map((alarm: any) => {
              if (alarm.link?.[0] !== "/") {
                return { ...alarm, link: "/" + alarm.link };
              } else return alarm;
            });
            setAlarms(data);
            setUnreadCount(result.data.unread_count);
          });
        })
        .catch((error) => {
          //로그인 되어있지 않음
          if (error?.response?.status === 401) {
            alert.showAlert(
              "다른 브라우저에서 로그인 혹은 로그아웃하여\n현재 브라우저에서 로그아웃 합니다.",
              () => {
                history.push(pages.index);
                clearUserInfo();
              }
            );
          }
        });
    }
  };

  useEffect(() => {
    checkUser();
  }, []);

  // ExpressCheckoutModal 자동 재오픈 로직
  useEffect(() => {
    // 랜딩 페이지에서만 실행
    if (location.pathname === '/lending') {
      const checkPendingCheckout = () => {
        try {
          const pendingData = localStorage.getItem('express_checkout_pending');
          if (pendingData) {
            const parsed = JSON.parse(pendingData);
            
            // 타임스탬프 검증 (5분 이내)
            if (Date.now() - parsed.timestamp < 300000) {
              console.log('자동 ExpressCheckoutModal 재오픈:', parsed);
              
              // 모달 데이터 복원
              setModalSelectedPlans(parsed.selectedPlans || []);
              setModalTotalAmount(parsed.selectedPlans?.reduce((sum, plan) => sum + (parsed.isSubscription ? plan.monthlyPrice : plan.yearlyPrice), 0) || 0);
              setModalIsMonthly(!parsed.isSubscription);
              
              // 자동으로 모달 열기
              setIsExpressModalOpen(true);
              
              // 로컬스토리지 정리 (ExpressCheckoutModal에서 처리)
              // localStorage.removeItem('express_checkout_pending');
            } else {
              // 만료된 데이터 제거
              localStorage.removeItem('express_checkout_pending');
            }
          }
        } catch (error) {
          console.error('Failed to check pending checkout:', error);
          localStorage.removeItem('express_checkout_pending');
        }
      };
      
      // DOM 완전 로드 후 1초 대기
      const timer = setTimeout(checkPendingCheckout, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  // 로그인 상태 변경 메시지 리스너 (랜딩페이지에서)
  useEffect(() => {
    if (location.pathname === '/lending') {
      const handleMessage = (event: MessageEvent) => {
        if (event.origin !== window.location.origin) return;
        
        if (event.data.type === 'LOGIN_STATUS_CHANGED') {
          console.log('로그인 상태 변경 감지:', event.data);
          
          // 로그인 상태 업데이트
          if (event.data.isLoggedIn) {
            setCurrentEmail(event.data.userInfo?.email);
            // 사용자 정보 다시 확인
            checkUser();
          } else {
            setCurrentEmail(undefined);
          }
        }
      };

      window.addEventListener('message', handleMessage);
      
      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, [location.pathname]);

  const viewAllAlarm = () => {
    try {
      api.viewAllAlarms().then((result) => checkUser());
    } catch (error) {
      console.error(error);
    }
  };

  const viewAlarm = async (index: number) => {
    try {
      await dlContext.checkDupLogin(() =>
        api.viewAlarm({
          id: alarms[index].id,
        })
      );
      await dlContext.checkDupLogin(() =>
        api.getAlarmsAsync(0, 10, false).then((result: any) => {
          const data = result?.data?.alarms?.map((alarm: any) => {
            if (alarm.link?.[0] !== "/") {
              return { ...alarm, link: "/" + alarm.link };
            } else return alarm;
          });
          setAlarms(data);
          setUnreadCount(result.data.unread_count);
        })
      );
      history.push(alarms[index].link);
    } catch (error) {
      console.error(error);
    }
  };

  // //알람 버튼 누를 시에 뜨는 menu 목록
  // const alertMenu = (
  //   <Menu className={styles["alarm-wrapper"]}>
  //     {alarms.map((alarm: any, index: number) => (
  //       <div
  //         onClick={() => viewAlarm(index)}
  //         className={`${styles["alarm-container"]} ${
  //           alarm.view ? styles.read : ""
  //         }`}
  //         key={index}
  //       >
  //         <div className={styles.ellipsis}>{alarm.text}</div>
  //       </div>
  //     ))}
  //     {alarms.length === 0 && (
  //       <div className={`${styles["alarm-container"]} ${styles.read}`}>
  //         <div className={styles.ellipsis}>읽지 않은 알람이 없습니다.</div>
  //       </div>
  //     )}
  //     {alarms.length > 0 && (
  //       <div className={styles["alarm-etc"]}>
  //         <span onClick={viewAllAlarm}>모두 읽음 처리</span>
  //       </div>
  //     )}
  //   </Menu>
  // );

  const logout = () => {
    api
      .logout()
      .then((result) => {
        auth.email = undefined;
        auth.lastName = undefined;
        setCurrentEmail(undefined);
        history.push("/");
      })
      .catch((error) => {
        window.location.reload();
        console.error(error);
      });
  };

  return (
    <CategoryProvider>
      <ExcelProvider>
        <TenantProvider value={tenantInfo}>
        <React.Fragment>
          <Switch>
            <Route path="*" exact>
              <div className={styles["app-wrap"]}>
                {/* 상단 메뉴 */}
                <Header currentEmail={currentEmail} ceTester={ceTester} unreadCount={unreadCount} tenant={tenantInfo} />
                <Switch>
                  <ScrollToTop>
                    <Route
                      path={`${pages.video}/(.*)?`}
                      exact
                      component={VideoMain}
                    />
                    <Route exact={true} path="/">
                      <MainContainer clearUserInfo={clearUserInfo} />
                    </Route>

                    <div className={styles["inner-body"]}>
                      <Route exact={true} path={pages.login}>
                        <LoginPage checkUser={checkUser} />
                      </Route>
                      <Route exact={true} path={`${pages.oauth2}/:provider`}>
                        <Callback checkUser={checkUser} />
                      </Route>
                      <Route exact={true} path={`${pages.cert}`}>
                        <SocialSignup checkUser={checkUser} />
                      </Route>
                      <Route exact={true} path={pages.worklists}>
                        <WorkListPage />
                      </Route>
                      <Route exact={true} path={pages.newwork}>
                        <NewWorkPage />
                      </Route>
                      <Route exact={true} path={pages.doclist}>
                        <DocList />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.worklists}/:id/documents`}
                      >
                        <Documents />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.worklists}/:id/documents/:chapter`}
                      >
                        <Documents />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.worklists}/:id/documents/PhotoList/:key`}
                      >
                        <Documents />
                      </Route>
                      <Route exact={true} path={pages.noticelist}>
                        <NoticeList />
                      </Route>
                      <Route exact={true} path={`${pages.notice}/:id`}>
                        <NoticeDetail />
                      </Route>

                      <Route exact={true} path={pages.signup}>
                        <SignUpPage />
                      </Route>
                      <Route exact={true} path={pages.welcome}>
                        <WelcomePage />
                      </Route>
                      <Route exact={true} path={pages.costprojects}>
                        <Redirect to={`${pages.costprojects}/normal`} />
                      </Route>
                      <Route exact={true} path={`${pages.costprojects}/:type`}>
                        <CostProjectsPage />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.costprojects}/detail/:id`}
                      >
                        <DupLoginContext.Consumer>
                          {(dupLogin) => (
                            <LoadingContext.Consumer>
                              {(loading) => (
                                <CostProjectsDetailPage
                                  dupLogin={dupLogin}
                                  loading={loading}
                                />
                              )}
                            </LoadingContext.Consumer>
                          )}
                        </DupLoginContext.Consumer>
                      </Route>
                      <Route exact={true} path={pages.mypage}>
                        <MyPageLayout child={<MyPage />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/video"}>
                        <MyPageLayout child={<MyPageVideo />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/payment-method"}>
                        <MyPageLayout child={<MyPagePaymentMethod />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/payment"}>
                        <MyPageLayout child={<MyPagePayment />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/qna"}>
                        <MyPageLayout child={<MyPageQna />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/qna/:id"}>
                        <MyPageLayout child={<MyPageQnaDetail />} />
                      </Route>
                      <Route
                        exact={true}
                        path={pages.mypage + "/qna/reply/:id"}
                      >
                        <MyPageLayout child={<MyPageQnaReplyDetail />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/contact"}>
                        <MyPageLayout child={<MyPageContact />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/contact/:id"}>
                        <MyPageLayout child={<MyPageContactDetail />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/posts"}>
                        <MyPageLayout child={<MyPosts />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/comments"}>
                        <MyPageLayout child={<MyComments />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/subscription"}>
                        <MyPageLayout child={<MyPagePaymentMethod />} />
                      </Route>
                      <Route exact={true} path={pages.mypage + "/permissions"}>
                        <MyPageLayout child={<UserPermissions />} />
                      </Route>
                      <Route exact={true} path={`${pages.lectureroom}`}>
                        <Redirect to={`${pages.lectureroom}/0`} />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.lectureroom}/:category`}
                      >
                        <LectureRoomContainer />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.lectureroom}/:category/:id`}
                      >
                        <LectureRoomStudyContainer />
                      </Route>
                      <Route exact={true} path={`${pages.inquiry}`}>
                        <InquiryContainer />
                      </Route>
                      <Route exact={true} path={`${pages.educationApplication}`}>
                        <EducationApplicationContainer />
                      </Route>
                      {/* <Route exact={true} path={`${pages.faq}`}>
                          <FaqContainer />
                        </Route> */}
                      <Route exact={true} path={`${pages.findaccount}`}>
                        <FindAccountContainer />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.payment}`}
                        render={({ location }) => (
                          <Redirect
                            to={{
                              pathname: pages.subscription,
                              search: location.search,
                            }}
                          />
                        )}
                      />

                      <Route exact={true} path={`${pages.subscription}`}>
                        <SubscriptionPaymentContainer />
                      </Route>
                      <Route exact={true} path={`${pages.paymentComplete}`}>
                        <PaymentComplete />
                      </Route>
                      <Route exact={true} path={`${pages.withdrawal}`}>
                        <MyPageLayout child={<WithdrawalContainer />} />
                      </Route>
                      <Route exact={true} path={`${pages.changepassword}`}>
                        <MyPageLayout child={<ChangePasswordContainer />} />
                      </Route>
                      <Route exact={true} path={`${pages.coupon}`}>
                        <MyPageLayout child={<CouponContainer />} />
                      </Route>
                      <Route exact={true} path={`${pages.statementlist}`}>
                        <SampleStatementListContainer />
                      </Route>
                      <Route exact={true} path={`${pages.contact}`}>
                        <Contact />
                      </Route>
                      <Route exact={true} path={`${pages.statementdetail}/:id`}>
                        <SampleStatementDetailContainer />
                      </Route>
                      <Route exact={true} path={`${pages.requestapplication}`}>
                        {/* <RequestApplication /> */}
                        <ServiceRequestDocContainer />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.requestapplication}/:type`}
                      >
                        {/* <RequestApplication /> */}
                        <RequestApplicationContainer />
                      </Route>
                      <Route exact={true} path={`${pages.inquiryboard}`}>
                        <InquiryBoard />
                      </Route>
                      <Route exact={true} path={`${pages.userboardlist}`}>
                        <UserBoardListContainer />
                      </Route>
                      <Route exact={true} path={`${pages.userboarddetail}/:id`}>
                        <UserBoardDetailContainer />
                      </Route>
                      <Route exact={true} path={`${pages.userboardform}`}>
                        <UserBoardFormContainer />
                      </Route>
                      <Route exact={true} path={`${pages.data}`}>
                        <DataListContainer />
                      </Route>
                      <Route exact={true} path={`${pages.data}/:id`}>
                        <DataDetailContainer />
                      </Route>
                      <Route exact={true} path={`${pages.cadpro}`}>
                        <CadProPage />
                      </Route>
                      {/* 검증: 메뉴 진입 링크 없이 URL(/verification) 직접 접근만 */}
                      <Route exact={true} path={`${pages.verification}`}>
                        <VerificationPage />
                      </Route>
                      <Route exact={true} path={`${pages.excel}`}>
                        <ExcelContainer />
                      </Route>
                      <Route exact={true} path={`${pages.excelContract}`}>
                        <ExcelContractContainer />
                      </Route>
                      <Route exact={true} path={`${pages.leveltest}/:id`}>
                        <LevelTestContainer />
                      </Route>
                      <Route exact={true} path={pages.community}>
                        <CommunityHub />
                      </Route>
                      <Route exact={true} path={`${pages.community}/:category`}>
                        <CommunityPage />
                      </Route>
                      <Route
                        exact={true}
                        path={`${pages.community}/:category/:id`}
                      >
                        <PostDetail />
                      </Route>
                      <Route exact={true} path={`${pages.communityAi}`}>
                        <AICommunityPage />
                      </Route>
                      <Route exact={true} path={`${pages.communityAi}/:id`}>
                        <AIPostDetail />
                      </Route>
                      <Route exact={true} path="/lending">
                        <Section1and2 />
                        <Section3and4 />
                        <Section5and6 />
                        <Section7and8 />
                        <Section9 />
                        
                        {/* ExpressCheckoutModal */}
                        <ExpressCheckoutModal 
                          isOpen={isExpressModalOpen}
                          onClose={() => setIsExpressModalOpen(false)}
                          selectedPlans={modalSelectedPlans}
                          totalAmount={modalTotalAmount}
                          isMonthly={modalIsMonthly}
                        />
                      </Route>
                    </div>
                  </ScrollToTop>
                </Switch>
                {!tenantInfo && <Footer />}
              </div>
              <AlarmModal alarms={alarms} />
            </Route>
          </Switch>
        </React.Fragment>
        </TenantProvider>
      </ExcelProvider>
    </CategoryProvider>
  );
}

export default App;
